export enum PLATFORMS {
  foam = 'foam',
  echo = 'echo',
}
